var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"loading",attrs:{"size":"sm","centered":"","hide-header":"","hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":"","content-class":"loading-modal"}},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"light"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }